import styled from "styled-components";

export const Label = styled.label`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  display: flex;
  gap: 5px;
  min-width: ${(prop) => `${prop.$widthLabel}px` || '273px'};
  text-align: left;

  .required {
    width : max-content;
    color: red;
    margin-left: 4px;
    }
  }
`;

export const BodyEditor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  align-items: ${(prop) => prop.$alignLabel || 'left'};
  width: ${(prop) => `${prop.$widthEditor}px` || '784px '};
  background: #ffffff;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  & ul {
    list-style-type: disc;
    padding-left: 40px;
  }

  & ol {
    list-style-type: decimal;
    padding-left: 40px;
  }

  & li {
    margin: 4px 0;
  }
`;
